export const shouldShowUnderline = (item, searchQuery) => item === 'underline'
